import { useNavigate } from 'react-router-dom'

import { useHighlightedBrands } from 'api/queries/useHighlightedBrands'
import EmptyLogo from 'assets/images/card-placeholder.png'
import { Button } from 'components/Button'
import { BVAList } from 'model/BVAList'
import { buildBvaDetailsPath } from 'utils/bvaSlug'

export const ListSection = () => {
  const { data, isLoading, isError } = useHighlightedBrands()
  const navigate = useNavigate()
  interface IsWithin60DaysFn {
    (dateString: string): boolean
  }

  const isWithin60Days: IsWithin60DaysFn = dateString => {
    const publishedDate = new Date(dateString)
    const today = new Date()

    const diffTime = today.getTime() - publishedDate.getTime() // difference in milliseconds
    const diffDays = diffTime / (1000 * 60 * 60 * 24)

    return diffDays <= 60
  }

  function redirectToBrandListPage() {
    navigate('/BVAFrameworks')
  }

  return (
    <div className=" mx-auto flex flex-col justify-center ">
      <p className="pt-20 pb-10 text-center title-xl">BVAs</p>
      <div className="brand-container">
        {isLoading ? null : data ? (
          data.map((brand: BVAList) => {
            const isRecent = brand.publishedOn ? isWithin60Days(brand.publishedOn) : false
            return (
              <div
                key={brand.id}
                className="relative h-[120px] brand-item cursor-pointer"
                onClick={() => navigate(buildBvaDetailsPath(brand.id, brand.brandName))}
              >
                <img
                  src={brand.logoUrl ? brand.logoUrl : brand.brandLogoUrl ? brand.brandLogoUrl : EmptyLogo}
                  alt={brand.brandName}
                  className="w-full justify-center align-center"
                />
                {isRecent ? (
                  <div className="h-8 px-2 py-1 -left-1.5 -top-1.5 absolute rounded-lg inline-flex justify-center items-center gap-1  brand-image-new-tag">
                    <div className="justify-start subtitle-xs uppercase leading-4">NEW</div>
                  </div>
                ) : null}
              </div>
            )
          })
        ) : isError ? (
          <p className="text-red-500 align-center">Error loading brands</p>
        ) : null}
      </div>
      <Button
        color="black"
        text="See all"
        className="mx-auto mt-8  mb-20 px-[16px] py-[10px]"
        onClick={redirectToBrandListPage}
      />
    </div>
  )
}
